import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import { UserContext } from "../context/UserContext";
import "../Styles/addCustReport.css";
import { useNavigate } from "react-router-dom";
import { clientApiUrl, reportApiUrl, taskApiUrl } from "../utils/GetUrl";
import ToastComponent from "../components/ToastComponent";
import {
  ListItemText,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  Tooltip,
  Typography,
  List,
  ListItem,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Popper,
  Button,
  ClickAwayListener,
  CircularProgress,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TableFooter,
  useTheme,
  Box,
} from "@mui/material";
import NavSub from "../components/NavSub";
import { Paper } from "@mui/material";
import "../Styles/DailyNew.css";
import {
  Check,
  PencilSimple,
  Trash,
  X,
  Download,
  Pencil,
} from "phosphor-react";

function DayNew() {
  const { usersList } = useContext(UserContext);
  const { userData } = useContext(AuthContext);
  const [selectedUser, setSelectedUser] = useState(userData?.[0]?.EM_ID);
  const loggedInEmId = userData?.[0]?.EM_ID;
  const isSelfUser = selectedUser === loggedInEmId;

  const toastRef = useRef();
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const buttonRef = useRef(null);

  const theme = useTheme();
  const [dailyReports, setDailyReports] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedMonthDate, setSelectedMonthDate] = useState(new Date());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [newDayTime, setNewDayTime] = useState(7.8);
  const [lockData, setLockData] = useState([]);
  const [selectedActivityId, setSelectedActivityId] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activityMapping, setActivityMapping] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [activityMappingnew, setActivityMappingnew] = useState({});
  const [activityToServiceMapping, setActivityToServiceMapping] = useState({});
  const [newd, setnewd] = useState({});
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [viewMode, setViewMode] = useState("daily");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editingRowId, setEditingRowId] = React.useState(null);
  const currentMonthYear = new Date().toISOString().substring(0, 7);
  const [editingCell, setEditingCell] = useState({ rowId: null, dayKey: null });
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [editedDayTime, setEditedDayTime] = useState(null);
  const [editingState, setEditingState] = useState({
    rowId: null,
    dayKey: null,
    value: null,
  });
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);
  const toggleDialog = () => setIsDialogOpen(!isDialogOpen);
  const isMonthLocked = (month, year) => {
    return lockData.some((item) => {
      const periodDate = new Date(item.PeriodDate);
      return (
        periodDate.getFullYear() === year && periodDate.getMonth() === month
      );
    });
  };

  const putData = async (id, updatedDayTime, updatedActivityId, dayNumber) => {
    const emIdToSend = selectedUser;
    if (!emIdToSend) return;

    // Check if month is locked
    if (isMonthLocked(selectedMonth, selectedYear)) {
      toastRef.current.showToast("PERIOD CLOSED", "error");
      return;
    }

    try {
      const response = await fetch(`${reportApiUrl}/UpdateDailyWiseReport`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify([
          {
            id,
            EmId: emIdToSend,
            ActivityId: updatedActivityId,
            DayTime: updatedDayTime,
            PreviousUpdatedDatetime: formatDate(
              new Date(selectedYear, selectedMonth, dayNumber)
            ),
          },
        ]),
      });
      const data = await response.json();
      if (data.Success) {
        fetchData(emIdToSend);
        setEditingState({ rowId: null, dayKey: null, value: null });
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const handleUpdate = (id, activityId, dayNumber) => {
    putData(id, editingState.value, activityId, dayNumber);
  };

  const handleCancelEdit = () => {
    setEditingState({ rowId: null, dayKey: null, value: null });
  };
  const getDaysInMonthWithWeekdays = (year, month) => {
    const days = [];
    let currentWeekNumber = 1;
    let date = new Date(year, month, 1);
    while (date.getMonth() === month) {
      const day = date.getDate();
      const dayOfWeek = date.getDay();
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
      const monthName = date.toLocaleString("default", { month: "short" });

      days.push({
        dayNumber: day,
        day: `${day}-${monthName}`,
        date: new Date(date),
        isWeekend,
        weekNumber: currentWeekNumber,
        dayOfWeek,
      });

      if (dayOfWeek === 6) {
        currentWeekNumber++;
      }

      // Move to next day
      date = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    }
    return days;
  };

  useEffect(() => {
    if (selectedMonth == null || selectedYear == null) return;
    const daysArray = getDaysInMonthWithWeekdays(selectedYear, selectedMonth);
    setDaysInMonth(daysArray);
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    setSelectedUser(userData?.[0]?.EM_ID);
  }, [userData]);

  const fetchActivityMapping = async () => {
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllActivity?Page=1&ItemsPerPage=1000`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();

      const filteredData = data.filter(
        (item) => item.AL_Type !== "Synergy Internal" && item.AL_Status !== 0
      );
      const uniqueBySalesforceCode = [];
      const seenCodes = new Set();

      filteredData.forEach((item) => {
        if (!seenCodes.has(item.AL_SalseforceCode)) {
          seenCodes.add(item.AL_SalseforceCode);
          uniqueBySalesforceCode.push(item);
        }
      });

      setFilteredActivities(uniqueBySalesforceCode);

      const dropdowndata = data.filter(
        (item) => item.AL_Type === "Synergy Internal"
      );

      const mappingnew = {};

      dropdowndata.forEach((item) => {
        mappingnew[item.AL_ID] = item.AL_SalseforceCode;
      });
      setActivityMappingnew(mappingnew);

      const mapping = {};
      const activityServiceMapping = {};

      data.forEach((item) => {
        mapping[item.AL_ID] = item.AL_SalseforceCode;
        activityServiceMapping[item.AL_ID] = item.Service;
      });

      setActivityMapping(mapping);
      setActivityToServiceMapping(activityServiceMapping);
    } catch (error) {
      console.error("Error fetching activity mapping:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchActivityMapping();
    }
  }, [token]);

  const formatDate = (date) => {
    const pad = (num) => num.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
  };

  const postData = async () => {
    const emIdToSend = userData?.[0]?.EM_ID;
    if (!emIdToSend || !daysInMonth || daysInMonth.length === 0) return;

    if (!selectedActivityId) {
      toastRef.current.showToast("Please select an activity first", "error");
      return;
    }

    // Check if current selected month-year is locked
    if (isMonthLocked(selectedMonth, selectedYear)) {
      toastRef.current.showToast("PERIOD CLOSED", "error");
      return;
    }

    let failCount = 0;
    let lastErrorMessage = "";
    const workingDays = daysInMonth;

    for (const day of workingDays) {
      try {
        const pad = (n) => n.toString().padStart(2, "0");
        const formattedDateTime = `${day.date.getFullYear()}-${pad(
          day.date.getMonth() + 1
        )}-${pad(day.date.getDate())}T00:00:00`;

        const response = await fetch(`${reportApiUrl}/CreateDailyWiseReport`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            EmId: emIdToSend,
            ActivityId: selectedActivityId,
            DayTime: 0,
            CreatedDateTime: formattedDateTime,
          }),
        });

        if (response.status === 401) {
          toastRef.current.showToast("Session expired. Please login again.", "error");
          return;
        }

        if (!response.ok) {
          failCount++;
          lastErrorMessage = `Server error ${response.status}`;
          continue;
        }

        const data = await response.json();
        if (!data.Success) {
          failCount++;
          lastErrorMessage = data.Message || "Unknown error";
        }
      } catch (error) {
        failCount++;
        lastErrorMessage = error.message;
        console.error(`Error posting for ${day.day}:`, error);
      }
    }

    if (failCount > 0) {
      toastRef.current.showToast(
        `${failCount} day(s) failed: ${lastErrorMessage}`,
        "error"
      );
    } else {
      toastRef.current.showToast("Report created successfully", "success");
    }

    fetchData(emIdToSend);
    toggleDialog();
  };

  const handleDeleteReport = async (id) => {
    try {
      const response = await fetch(
        `${reportApiUrl}/DeleteDailyWiseReport?id=${id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok)
        throw new Error(`Failed to delete. Status: ${response.status}`);

      const result = await response.text();
      const parsed = JSON.parse(result);

      if (parsed?.Success) {
        setDailyReports((prev) => prev.filter((report) => report.id !== id));
      } else {
        console.error(
          "Error deleting data:",
          parsed?.Message || "Empty response"
        );
      }
    } catch (error) {
      console.error("Error deleting report:", error);
    }
  };

  const openDeleteDialog = (id) => {
    setReportToDelete(id);
    setIsConfirmDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setIsConfirmDialogOpen(false);
    setReportToDelete(null);
  };

  const confirmDeleteReport = async () => {
    if (reportToDelete !== null) {
      await handleDeleteReport(reportToDelete);
      closeDeleteDialog();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    postData();
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      return;
    }
    const results = usersList.filter((user) =>
      `${user.EM_FirstName} ${user.EM_LastName}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );

    setSearchResults(results);
    setIsSearching(true);
  };
  const handleUserSelect = (userId) => {
    setSelectedUser(userId);
    setIsSearching(false);
    setSearchTerm("");
    setSearchResults([]);
  };

  const getSelectedUserName = () => {
    if (!selectedUser || !usersList) return "";
    const user = usersList.find((u) => u.EM_ID === selectedUser);
    return user ? `${user.EM_FirstName} ${user.EM_LastName}` : "";
  };

  const handleDateChange = (event) => {
    const value = event.target.value;
    const [year, month] = value.split("-").map(Number);

    const newDate = new Date(year, month - 1);
    setSelectedMonthDate(newDate);
    setSelectedMonth(month - 1); // 0-based
    setSelectedYear(year); // <-- this was missing
    setCurrentYear(year);
  };

  const formatedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [stdHoursData, setStdHoursData] = useState(null);

  useEffect(() => {
    const fetchStdHours = async () => {
      try {
        const response = await fetch(`${reportApiUrl}/GetHoursInReport`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        const parsedHours = parseFloat(data?.Result?.Hours);
        setStdHoursData(isNaN(parsedHours) ? 0 : parsedHours);
      } catch (error) {
        console.error("Error fetching stdHours:", error);
      }
    };

    if (token && reportApiUrl) {
      fetchStdHours();
    }
  }, [token, reportApiUrl]);
  const fetchData = async (emId) => {
    if (!emId) return;

    const startDate = new Date(
      selectedMonthDate.getFullYear(),
      selectedMonthDate.getMonth(),
      1
    );
    const endDate = new Date(
      selectedMonthDate.getFullYear(),
      selectedMonthDate.getMonth() + 1,
      0
    );

    try {
      const response = await fetch(
        `${reportApiUrl}/GetByIdDailyWiseReport?EmId=${emId}&StartDate=${formatDate(
          startDate
        )}&EndDate=${formatDate(endDate)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();
      setDailyReports(data.Result || []);
    } catch (error) {
      console.error("Error fetching daily reports:", error);
    } finally {
      setIsLoading(false); // ✅ Add this here
    }
  };

  useEffect(() => {
    if (selectedUser && token) {
      fetchData(selectedUser);
    }
  }, [selectedUser, token, selectedMonthDate]);
  const filteredReports = dailyReports.filter((report) => {
    if (!report.CreatedDate) return false;
    const reportDate = new Date(report.CreatedDate);
    return reportDate.getMonth() === selectedMonth;
  });

  const groupedReports = filteredReports.reduce((acc, report) => {
    const key = report.ActivityId;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(report);
    return acc;
  }, {});

  const weekdays = daysInMonth.filter((d) => !d.isWeekend);

  const fetchInData = async (emId) => {
    const startDate = new Date(
      selectedMonthDate.getFullYear(),
      selectedMonthDate.getMonth(),
      1
    );
    const endDate = new Date(
      selectedMonthDate.getFullYear(),
      selectedMonthDate.getMonth() + 1,
      0
    );

    const formattedStartDate = formatedDate(startDate);
    const formattedEndDate = formatedDate(endDate);

    let url = `${taskApiUrl}/GetReportByEmId?dateRange1=${formattedStartDate}&dateRange2=${formattedEndDate}&EmId=${emId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      setnewd(result);
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  };
  useEffect(() => {
    if (selectedUser && token) {
      fetchInData(selectedUser);
      fetchData(selectedUser);
    }
  }, [selectedUser, token, selectedMonthDate]);

  const yourWeekTotals = Array.from(
    { length: Math.ceil(daysInMonth.length / 7) },
    (_, weekIdx) => {
      const weekDays = daysInMonth.slice(weekIdx * 7, (weekIdx + 1) * 7);

      // Sum a specific field for the week (e.g., dayObj.value)
      return weekDays.reduce((sum, day) => sum + (day.value || 0), 0);
    }
  );

  const handleToggle = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setDropdownOpen(false);
  };

  const onUserSelect = (userId) => {
    handleUserSelect(userId);
    setDropdownOpen(false);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    handleSearch("");
  };
  useEffect(() => {
    if (userData?.length > 0 && !selectedUser) {
      setSelectedUser(userData[0].EM_ID);
    }
  }, [userData, selectedUser]);

  useEffect(() => {
    if (selectedUser && token) {
      fetchData(selectedUser);
    }
  }, [selectedUser, token]);

  const total =
    dailyReports?.reduce((total, report) => {
      return (
        total +
        weekdays.reduce((sum, d) => sum + (report[`Day${d.dayNumber}`] || 0), 0)
      );
    }, 0) || 0;

  const stdDaysCount = daysInMonth.filter((d) => !d.isWeekend).length;
  const stdVfMonthly = stdDaysCount * (stdHoursData || 0);
  const stdMonthly = stdVfMonthly;
  const stdDiffMonthly = 0;

  const reportTimes =
    filteredReports?.flatMap((report) => {
      let reportSum = 0;

      const dayTimes = Object.keys(report)
        .filter((key) => /^Day\d+$/.test(key))
        .map((key) => {
          const time = report[key] || 0;
          if (time > 0) {
            reportSum += time;
          }
          return time;
        });

      return dayTimes;
    }) || [];

  const reportTotal = reportTimes.reduce((sum, t) => sum + t, 0);

  const activityTimes =
    filteredActivities?.flatMap((activity) => {
      const activityEntries =
        newd.Result?.[0]?.filter(
          (entry) =>
            entry.Activity?.toLowerCase() ===
            activity.AL_SalseforceCode?.toLowerCase()
        ) || [];

      return activityEntries.map((entry) => {
        const time = entry.TotalRegisteredTime || 0;
        return time;
      });
    }) || [];

  const activityTotal = activityTimes.reduce((sum, t) => sum + t, 0);

  const [activeView, setActiveView] = useState("daily");
  const handleDownload = async () => {
    try {
      const XLSX = await import("xlsx");
      const table = document.querySelector("table"); // Gets the visible table

      if (!table) {
        throw new Error("No table found for export");
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.table_to_sheet(table);

      // Auto-adjust column widths (optional)
      const range = XLSX.utils.decode_range(ws["!ref"]);
      const cols = [];
      for (let i = 0; i <= range.e.c; i++) {
        cols.push({ wch: 15 }); // Default width (adjust as needed)
      }
      ws["!cols"] = cols;

      XLSX.utils.book_append_sheet(wb, ws, `${viewMode} Data`);

      // Use viewMode in filename (e.g., "Daily_Export_2024-06-15.xlsx")
      const date = new Date().toISOString().split("T")[0];
      XLSX.writeFile(wb, `${viewMode}_Export_${date}.xlsx`);
    } catch (error) {
      console.error("Export failed:", error);
      alert("Failed to export: " + error.message);
    }
  };

  const getAllActivityLock = async () => {
    if (!token) {
      return;
    }
    const response = await fetch(
      `${taskApiUrl}/GetAllActivityLock?PeriodDateYear=${currentYear}&GetHistory=false`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (response?.status === 401) {
      navigate("/");
    }
    const data = await response.json();
    const dayWiseLock = data.filter((item) => item.Type === "DayWise");

    setLockData(dayWiseLock);
  };
  useEffect(() => {
    getAllActivityLock();
  }, []);
  return (
    <div>
      <NavSub />
      <div className="dailywiseconatinertable">
        <FormControl fullWidth variant="outlined" sx={{ width: 300 }}>
          <ClickAwayListener onClickAway={handleClickAway}>
            <Box>
              {/* Dropdown Button with selected user */}
              <Button
                variant="outlined"
                fullWidth
                ref={buttonRef}
                onClick={handleToggle}
                sx={{
                  justifyContent: "flex-start",
                  mt: 1,
                  borderColor: "#50145a !important",
                  color: "#50145a !important",
                  "&:hover": {
                    borderColor: "#50145a !important",
                    backgroundColor: "rgba(80, 20, 90, 0.1)", // subtle hover background
                  },
                }}
              >
                {selectedUser
                  ? getSelectedUserName()
                  : "Click to select a preparer"}
              </Button>

              {/* Popper-style dropdown */}
              <Popper
                open={dropdownOpen}
                anchorEl={buttonRef.current}
                placement="bottom-start"
                style={{ zIndex: 1300, width: buttonRef.current?.offsetWidth }}
              >
                <Paper sx={{ p: 2, mt: 1 }}>
                  {/* Search Input */}
                  <Box display="flex" gap={1} mb={1}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      placeholder="Search by name..."
                      value={searchTerm}
                      onChange={(e) => {
                        handleSearchChange(e);
                        handleSearch(e.target.value); // Search on every keystroke
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#50145a !important",
                          },
                          "&:hover fieldset": {
                            borderColor: "#50145a !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#50145a !important",
                          },
                        },
                      }}
                    />
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={handleClearSearch}
                    >
                      Clear
                    </Button>
                  </Box>

                  {/* Search Results */}
                  <List dense sx={{ maxHeight: 200, overflow: "auto" }}>
                    {searchResults.length > 0 ? (
                      searchResults.map((user) => (
                        <ListItem
                          key={user.EM_ID}
                          button
                          onClick={() => onUserSelect(user.EM_ID)}
                          sx={{
                            "&:hover": { backgroundColor: "action.hover" },
                          }}
                        >
                          <ListItemText
                            primary={`${user.EM_FirstName} ${user.EM_LastName}`}
                          />
                        </ListItem>
                      ))
                    ) : (
                      <ListItem>
                        <ListItemText primary="No results found" />
                      </ListItem>
                    )}
                  </List>
                </Paper>
              </Popper>
            </Box>
          </ClickAwayListener>
        </FormControl>
        <div className="flex gap-2">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <TextField
              color="primary"
              variant="outlined"
              fullWidth
              type="month"
              onChange={handleDateChange}
              defaultValue={currentMonthYear}
              style={{ width: "180px" }}
            />

            <Button
              variant="outlined"
              color="primary"
              onClick={toggleDialog}
              sx={{
                width: "200px",
                borderColor: "#50145a !important",
                color: "#50145a !important",
                "&:hover": {
                  borderColor: "#50145a !important",
                  backgroundColor: "rgba(80, 20, 90, 0.1)", // subtle hover bg
                },
              }}
            >
              Add Report
            </Button>
          </div>
          <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <div className="cust_common_btn" onClick={() => handleDownload()}>
              <Download weight="fill" size={20} /> DOWNLOAD
            </div>
            <Button
              variant={viewMode === "daily" ? "contained" : "outlined"}
              onClick={() => setViewMode("daily")}
              style={{
                width: "180px",
                marginRight: "10px",
                backgroundColor:
                  viewMode === "daily" ? "rgb(80, 20, 90)" : "transparent",
                color: viewMode === "daily" ? "#fff" : "#50145a",
                borderColor: "#50145a",
              }}
            >
              Daily View
            </Button>

            <Button
              variant={viewMode === "weekly" ? "contained" : "outlined"}
              onClick={() => setViewMode("weekly")}
              style={{
                width: "180px",
                backgroundColor:
                  viewMode === "weekly" ? "rgb(80, 20, 90)" : "transparent",
                color: viewMode === "weekly" ? "#fff" : "#50145a",
                borderColor: "#50145a",
              }}
            >
              Weekly View
            </Button>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress style={{ color: "#50145a" }} />
        </div>
      ) : (
        <div
          style={{ display: "flex", justifyContent: "center", height: "72vh" }}
        >
          <TableContainer
            component={Paper}
            sx={{
              maxWidth: "98%",

              overflowX: "auto",
              "&::-webkit-scrollbar": {
                height: 10,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: 4,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#50145a",
                borderRadius: 4,
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            <Table stickyHeader sx={{ minWidth: 1600 }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "rgb(217, 217, 217)",
                      zIndex: 3,
                      minWidth: 400,
                    }}
                  >
                    View Force Project Code
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 400,
                      backgroundColor: "rgb(217, 217, 217)",
                      zIndex: 3,
                      minWidth: 300,
                      width: 300,
                    }}
                  >
                    Services
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      position: "sticky",
                      left: 600,
                      backgroundColor: "rgb(217, 217, 217)",
                      zIndex: 3,
                      minWidth: 100,
                      width: 100,
                    }}
                  >
                    Actions
                  </TableCell> */}

                  {/* Dynamic Columns */}
                  {viewMode === "daily"
                    ? (() => {
                        // ✅ CHANGE HERE
                        const allDays = daysInMonth;

                        return allDays.map((dayObj, index) => {
                          const weekNumber = dayObj.weekNumber;

                          // ✅ CHANGE LOGIC
                          const isLastDayOfWeek =
                            index === allDays.length - 1 ||
                            allDays[index + 1].weekNumber !== weekNumber;

                          return (
                            <React.Fragment key={`day-header-${index}`}>
                              <TableCell
                                align="center"
                                sx={{
                                  minWidth: 100,
                                  backgroundColor: dayObj.isWeekend
                                    ? "#F2F2F2"
                                    : "white",
                                  fontWeight: dayObj.isWeekend
                                    ? "bold"
                                    : "normal",
                                }}
                              >
                                {dayObj.day}
                              </TableCell>

                              {isLastDayOfWeek && (
                                <TableCell
                                  sx={{
                                    minWidth: 100,
                                    fontWeight: "bold",
                                    backgroundColor: "#A9A9A9",
                                  }}
                                >
                                  Week {weekNumber} Total
                                </TableCell>
                              )}
                            </React.Fragment>
                          );
                        });
                      })()
                    : Array.from({ length: yourWeekTotals.length }).map(
                        (_, weekIdx) => (
                          <React.Fragment key={`week-header-${weekIdx}`}>
                            <TableCell
                              sx={{
                                minWidth: 100,
                                fontWeight: "bold",
                                backgroundColor: "#A9A9A9",
                              }}
                            >
                              Week {weekIdx + 1} Total
                            </TableCell>
                          </React.Fragment>
                        )
                      )}

                  {/* Fixed Total Columns HEADERS TOTAL VF DIFFERENCE */}
                  {/* <TableCell
                    sx={{
                      position: "sticky",
                      right: 200,
                      backgroundColor: "#A9A9A9",
                      zIndex: 10,
                      minWidth: 100,
                    }}
                  >
           VF 
                  </TableCell> */}
                  <TableCell
                    sx={{
                      minWidth: 100,
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#A9A9A9",
                      zIndex: 10,
                    }}
                  >
                    Total
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      minWidth: 100,
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#A9A9A9",
                      zIndex: 10,
                    }}
                  >
                    DIFF
                  </TableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredActivities?.map((activity, index) => {
                  const activityEntries =
                    newd.Result?.[0]?.filter((entry) => {
                      const a = String(entry?.Activity || "").toLowerCase();
                      const b = String(
                        activity?.AL_SalseforceCode || ""
                      ).toLowerCase();
                      return a !== "" && a === b;
                    }) || [];

                  const dateMap = {};
                  activityEntries.forEach((entry) => {
                    const date = new Date(
                      entry.DateIncurred
                    ).toLocaleDateString("en-US");
                    dateMap[date] =
                      (dateMap[date] || 0) + (entry.TotalRegisteredTime || 0);
                  });

                  const totalTime = Object.values(dateMap).reduce(
                    (sum, time) => sum + time,
                    0
                  );

                  const allDays = daysInMonth; // ✅ Mon–Sun

                  const rowBgColor = index % 2 === 0 ? "#f9f9f9" : "#ffffff";

                  return (
                    <TableRow key={index}>
                      {/* Fixed Columns */}
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: rowBgColor,
                          zIndex: 2,
                        }}
                      >
                        {activity.AL_SalseforceCode}
                      </TableCell>

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 400,
                          backgroundColor: rowBgColor,
                          zIndex: 2,
                        }}
                      >
                        {activity.Service}
                      </TableCell>

                      {/* ================= DAILY VIEW ================= */}
                      {viewMode === "daily"
                        ? (() => {
                            return allDays.map((dayObj, dayIndex) => {
                              const dateStr =
                                dayObj.date.toLocaleDateString("en-US");
                              const timeForDay = dateMap[dateStr] || 0;
                              const weekNumber = dayObj.weekNumber;

                              const weekDays = allDays.filter(
                                (d) => d.weekNumber === weekNumber
                              );

                              const isLastDayOfWeek =
                                dayIndex === allDays.length - 1 ||
                                allDays[dayIndex + 1]?.weekNumber !==
                                  weekNumber;

                              return (
                                <React.Fragment key={`day-data-${dayIndex}`}>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      backgroundColor: dayObj.isWeekend
                                        ? "#F2F2F2"
                                        : rowBgColor,
                                    }}
                                  >
                                    {timeForDay > 0 ? timeForDay : "0"}
                                  </TableCell>

                                  {isLastDayOfWeek && (
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        backgroundColor: "#e0e0e0",
                                      }}
                                    >
                                      {weekDays
                                        .reduce((total, d) => {
                                          const dStr =
                                            d.date.toLocaleDateString("en-US");
                                          return total + (dateMap[dStr] || 0);
                                        }, 0)
                                        .toFixed(2)}
                                    </TableCell>
                                  )}
                                </React.Fragment>
                              );
                            });
                          })()
                        : /* ================= WEEKLY VIEW ================= */
                          (() => {
                            const uniqueWeeks = [
                              ...new Set(allDays.map((d) => d.weekNumber)),
                            ];

                            return uniqueWeeks.map((weekNumber, weekIdx) => {
                              const weekDays = allDays.filter(
                                (d) => d.weekNumber === weekNumber
                              );

                              const weekTotal = weekDays.reduce((total, d) => {
                                const dStr = d.date.toLocaleDateString("en-US");
                                return total + (dateMap[dStr] || 0);
                              }, 0);

                              return (
                                <TableCell
                                  key={`week-data-${weekIdx}`}
                                  sx={{
                                    fontWeight: "bold",
                                    backgroundColor: "#e0e0e0",
                                  }}
                                >
                                  {weekTotal.toFixed(2)}
                                </TableCell>
                              );
                            });
                          })()}

                      {/* Fixed Total Column */}
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          backgroundColor: "#e0e0e0",
                          position: "sticky",
                          right: 0,
                          zIndex: 2,
                        }}
                      >
                        {totalTime > 0 ? totalTime.toFixed(2) : "0"}
                      </TableCell>
                    </TableRow>
                  );
                })}

                {Object.entries(groupedReports)
                  .filter(([_, reports]) => reports.some((r) => r.id))
                  .map(([activityId, reports], rowIndex) => {
                    const rowBgColor =
                      rowIndex % 2 === 0
                        ? theme.palette.grey[50]
                        : theme.palette.background.paper;

                    const dailyValues = {};
                    const weeklyTotals = {};
                    const workingDaysInWeek = {};

                    let monthlyTotal = 0;

                    /* ---------- UNIQUE WEEKS (IMPORTANT FIX) ---------- */
                    const uniqueWeeks = [
                      ...new Set(daysInMonth.map((d) => d.weekNumber)),
                    ];

                    /* ---------- COUNT WORKING DAYS ---------- */
                    daysInMonth.forEach((day) => {
                      if (!day.isWeekend) {
                        workingDaysInWeek[day.weekNumber] =
                          (workingDaysInWeek[day.weekNumber] || 0) + 1;
                      }
                    });

                    /* ---------- DAILY & WEEKLY TOTALS ---------- */
                    daysInMonth.forEach((dayObj) => {
                      const dayNumber = dayObj.dayNumber;

                      const dayReport = reports.find((r) => {
                        const d = new Date(r.CreatedDate);
                        return d.getDate() === dayNumber;
                      });

                      const value = dayReport?.DayTime || 0;

                      dailyValues[dayNumber] = {
                        actual: value,
                        reportId: dayReport?.id || null,
                      };

                      weeklyTotals[dayObj.weekNumber] =
                        (weeklyTotals[dayObj.weekNumber] || 0) + value;

                      monthlyTotal += value;
                    });

                    return (
                      <TableRow
                        key={activityId}
                        sx={{ backgroundColor: rowBgColor }}
                      >
                        {/* ===== FIXED COLUMNS ===== */}
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            zIndex: 2,
                            minWidth: 400,
                            backgroundColor: rowBgColor,
                          }}
                        >
                          {activityMapping[activityId] || activityId}
                        </TableCell>

                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 400,
                            zIndex: 2,
                            minWidth: 200,
                            backgroundColor: rowBgColor,
                          }}
                        >
                          {activityToServiceMapping[activityId] || "N/A"}
                        </TableCell>

                        {/* ===== DAILY VIEW ===== */}
                        {viewMode === "daily" &&
                          daysInMonth.map((dayObj, index) => {
                            const dayNumber = dayObj.dayNumber;
                            const cellData = dailyValues[dayNumber];
                            const currentValue = cellData?.actual || 0;
                            const reportId = cellData?.reportId;

                            const isEditing =
                              isSelfUser &&
                              editingState.rowId === reportId &&
                              editingState.dayKey === `Day${dayNumber}`;

                            const isLastDayOfWeek =
                              index === daysInMonth.length - 1 ||
                              daysInMonth[index + 1].weekNumber !==
                                dayObj.weekNumber;

                            return (
                              <React.Fragment
                                key={`${activityId}-${dayNumber}`}
                              >
                                <TableCell
                                  align="center"
                                  sx={{
                                    minWidth: 100,
                                    cursor:
                                      isSelfUser && reportId
                                        ? "pointer"
                                        : "not-allowed",

                                    backgroundColor: isEditing
                                      ? theme.palette.action.selected
                                      : dayObj.isWeekend
                                      ? "#F2F2F2"
                                      : "inherit",
                                  }}
                                  onClick={() => {
                                    if (!isSelfUser) return; // 🚫 BLOCK other users
                                    if (!reportId) return;

                                    setEditingState({
                                      rowId: reportId,
                                      dayKey: `Day${dayNumber}`,
                                      value: currentValue,
                                    });
                                  }}
                                >
                                  {isEditing ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <TextField
                                        type="number"
                                        size="small"
                                        value={editingState.value}
                                        autoFocus
                                        inputProps={{ min: 0, step: 0.5 }}
                                        sx={{ width: 70, mr: 1 }}
                                        onChange={(e) =>
                                          setEditingState({
                                            ...editingState,
                                            value: Number(e.target.value) || 0,
                                          })
                                        }
                                      />

                                      {/* SAVE */}
                                      <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleUpdate(
                                            editingState.rowId,
                                            activityId,
                                            dayNumber
                                          );
                                        }}
                                      >
                                        <Check fontSize="small" />
                                      </IconButton>

                                      {/* CANCEL (X) */}
                                      <IconButton
                                        size="small"
                                        color="error"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEditingState({
                                            rowId: null,
                                            dayKey: null,
                                            value: 0,
                                          });
                                        }}
                                      >
                                        <X fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  ) : (
                                    <Typography>{currentValue}</Typography>
                                  )}
                                </TableCell>

                                {/* WEEK TOTAL CELL */}
                                {isLastDayOfWeek && (
                                  <TableCell
                                    sx={{
                                      minWidth: 100,
                                      fontWeight: "bold",
                                      backgroundColor: "#e0e0e0",
                                    }}
                                  >
                                    {(
                                      weeklyTotals[dayObj.weekNumber] || 0
                                    ).toFixed(2)}
                                  </TableCell>
                                )}
                              </React.Fragment>
                            );
                          })}

                        {/* ===== WEEKLY VIEW (FIXED) ===== */}
                        {viewMode === "weekly" &&
                          uniqueWeeks.map((weekNumber) => (
                            <TableCell
                              key={`${activityId}-week-${weekNumber}`}
                              sx={{
                                minWidth: 100,
                                fontWeight: "bold",
                                backgroundColor: "#e0e0e0",
                              }}
                            >
                              {(weeklyTotals[weekNumber] || 0).toFixed(2)}
                            </TableCell>
                          ))}

                        {/* ===== MONTH TOTAL ===== */}
                        <TableCell
                          sx={{
                            position: "sticky",
                            right: 0,
                            zIndex: 2,
                            minWidth: 100,
                            fontWeight: "bold",
                            backgroundColor: "#e0e0e0",
                          }}
                        >
                          {monthlyTotal.toFixed(2)}
                        </TableCell>
                      </TableRow>
                    );
                  })}

                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "rgb(217, 217, 217)",
                      zIndex: 2,
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </TableCell>
                  {viewMode === "daily"
                    ? (() => {
                        const allDays = daysInMonth;

                        return allDays.map((dayObj, index) => {
                          const dayNumber = dayObj.dayNumber;
                          const dateStr =
                            dayObj.date.toLocaleDateString("en-US");

                          // ----- Daily total from activities -----
                          const activitiesDayTotal =
                            filteredActivities?.reduce((sum, activity) => {
                              const activityEntries =
                                newd.Result?.[0]?.filter(
                                  (entry) =>
                                    entry.Activity?.toLowerCase() ===
                                    activity.AL_SalseforceCode?.toLowerCase()
                                ) || [];

                              const entriesForDay = activityEntries.filter(
                                (entry) =>
                                  new Date(
                                    entry.DateIncurred
                                  ).toLocaleDateString("en-US") === dateStr
                              );

                              return (
                                sum +
                                entriesForDay.reduce(
                                  (s, e) => s + (e.TotalRegisteredTime || 0),
                                  0
                                )
                              );
                            }, 0) || 0;

                          // ----- Daily total from reports -----
                          const reportsDayTotal = Object.values(
                            groupedReports
                          ).reduce((sum, reports) => {
                            const dayReport = reports.find((r) => {
                              const d = new Date(r.CreatedDate);
                              return d.getDate() === dayNumber;
                            });
                            return sum + (dayReport?.DayTime || 0);
                          }, 0);

                          const dayTotal = activitiesDayTotal + reportsDayTotal;

                          const currentWeekNumber = dayObj.weekNumber;
                          const currentWeekDays = allDays.filter(
                            (d) => d.weekNumber === currentWeekNumber
                          );

                          const isLastDayOfWeek =
                            index === allDays.length - 1 ||
                            allDays[index + 1].weekNumber !== currentWeekNumber;

                          return (
                            <React.Fragment key={`vf-daily-${index}`}>
                              <TableCell
                                align="center"
                                sx={{
                                  fontWeight: "bold",
                                  backgroundColor: dayObj.isWeekend
                                    ? "#F2F2F2"
                                    : "inherit",
                                }}
                              >
                                {dayTotal.toFixed(2)}
                              </TableCell>

                              {isLastDayOfWeek && (
                                <TableCell
                                  sx={{
                                    fontWeight: "bold",
                                    backgroundColor: "#e0e0e0",
                                  }}
                                >
                                  {currentWeekDays
                                    .reduce((weekSum, d) => {
                                      const dStr =
                                        d.date.toLocaleDateString("en-US");

                                      const actTotal =
                                        filteredActivities?.reduce((s, a) => {
                                          const entries =
                                            newd.Result?.[0]?.filter(
                                              (e) =>
                                                e.Activity?.toLowerCase() ===
                                                a.AL_SalseforceCode?.toLowerCase()
                                            ) || [];
                                          return (
                                            s +
                                            entries
                                              .filter(
                                                (e) =>
                                                  new Date(
                                                    e.DateIncurred
                                                  ).toLocaleDateString(
                                                    "en-US"
                                                  ) === dStr
                                              )
                                              .reduce(
                                                (x, e) =>
                                                  x +
                                                  (e.TotalRegisteredTime || 0),
                                                0
                                              )
                                          );
                                        }, 0) || 0;

                                      const repTotal = Object.values(
                                        groupedReports
                                      ).reduce((s, reps) => {
                                        const r = reps.find(
                                          (r) =>
                                            new Date(
                                              r.CreatedDate
                                            ).getDate() === d.dayNumber
                                        );
                                        return s + (r?.DayTime || 0);
                                      }, 0);

                                      return weekSum + actTotal + repTotal;
                                    }, 0)
                                    .toFixed(2)}
                                </TableCell>
                              )}
                            </React.Fragment>
                          );
                        });
                      })()
                    : /* ================= WEEKLY VIEW ================= */
                      (() => {
                        const uniqueWeeks = [
                          ...new Set(daysInMonth.map((d) => d.weekNumber)),
                        ];

                        return uniqueWeeks.map((weekNumber, weekIdx) => {
                          const weekDays = daysInMonth.filter(
                            (d) => d.weekNumber === weekNumber
                          );

                          const weekTotal =
                            filteredActivities?.reduce(
                              (activitySum, activity) => {
                                const activityEntries =
                                  newd.Result?.[0]?.filter(
                                    (entry) =>
                                      entry.Activity?.toLowerCase() ===
                                      activity.AL_SalseforceCode?.toLowerCase()
                                  ) || [];

                                return (
                                  activitySum +
                                  weekDays.reduce((daySum, dayObj) => {
                                    const dateStr =
                                      dayObj.date.toLocaleDateString("en-US");
                                    return (
                                      daySum +
                                      activityEntries
                                        .filter(
                                          (e) =>
                                            new Date(
                                              e.DateIncurred
                                            ).toLocaleDateString("en-US") ===
                                            dateStr
                                        )
                                        .reduce(
                                          (s, e) =>
                                            s + (e.TotalRegisteredTime || 0),
                                          0
                                        )
                                    );
                                  }, 0)
                                );
                              },
                              0
                            ) +
                            Object.values(groupedReports).reduce(
                              (repSum, reports) => {
                                return (
                                  repSum +
                                  weekDays.reduce((s, d) => {
                                    const r = reports.find(
                                      (r) =>
                                        new Date(r.CreatedDate).getDate() ===
                                        d.dayNumber
                                    );
                                    return s + (r?.DayTime || 0);
                                  }, 0)
                                );
                              },
                              0
                            );

                          return (
                            <TableCell
                              key={`vf-week-${weekIdx}`}
                              sx={{
                                fontWeight: "bold",
                                backgroundColor: "#e0e0e0",
                              }}
                            >
                              {weekTotal.toFixed(2)}
                            </TableCell>
                          );
                        });
                      })()}

                  {/* Fixed Total Columns */}
                  {/* <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 200,
                      zIndex: 2,
                    }}
                  >
                    {Object.values(groupedReports)
                      .reduce((sum, reports) => {
                        return (
                          sum +
                          reports.reduce((reportSum, report) => {
                            return reportSum + (report.VFTime || 0);
                          }, 0)
                        );
                      }, 0)
                      .toFixed(2)}
                  </TableCell> */}

                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                    }}
                  >
                    {(
                      (filteredActivities?.reduce((sum, activity) => {
                        const activityEntries =
                          newd.Result?.[0]?.filter(
                            (entry) =>
                              entry.Activity?.toLowerCase() ===
                              activity.AL_SalseforceCode?.toLowerCase()
                          ) || [];

                        return (
                          sum +
                          activityEntries.reduce(
                            (entrySum, entry) =>
                              entrySum + (entry.TotalRegisteredTime || 0),
                            0
                          )
                        );
                      }, 0) || 0) +
                      Object.values(groupedReports).reduce((sum, reports) => {
                        return (
                          sum +
                          reports.reduce((reportSum, report) => {
                            return reportSum + (report.DayTime || 0);
                          }, 0)
                        );
                      }, 0)
                    ).toFixed(2)}
                  </TableCell>

                  {/* <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                    }}
                  >
                    {(
                      (filteredActivities?.reduce((sum, activity) => {
                        const activityEntries =
                          newd.Result?.[0]?.filter(
                            (entry) =>
                              entry.Activity === activity.AL_SalseforceCode
                          ) || [];
                        return (
                          sum +
                          activityEntries.reduce(
                            (entrySum, entry) =>
                              entrySum + (entry.TotalRegisteredTime || 0),
                            0
                          )
                        );
                      }, 0) || 0) +
                      Object.values(groupedReports).reduce((sum, reports) => {
                        return (
                          sum +
                          reports.reduce((reportSum, report) => {
                            return (
                              reportSum +
                              ((report.DayTime || 0) - (report.VFTime || 0))
                            );
                          }, 0)
                        );
                      }, 0)
                    ).toFixed(2)}
                  </TableCell> */}
                </TableRow>

                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "rgb(217, 217, 217)",
                      zIndex: 2,
                      fontWeight: "bold",
                    }}
                  >
                    STD
                  </TableCell>

                  {viewMode === "daily"
                    ? (() => {
                        const allDays = daysInMonth;

                        return allDays.map((dayObj, index) => {
                          const isLastDayOfWeek =
                            index === allDays.length - 1 ||
                            allDays[index + 1].weekNumber !== dayObj.weekNumber;

                          const currentWeekWorkingDays = allDays.filter(
                            (d) =>
                              d.weekNumber === dayObj.weekNumber && !d.isWeekend
                          );

                          const expectedWeekTotal =
                            currentWeekWorkingDays.length * stdHoursData;

                          return (
                            <React.Fragment key={`vf-daily-${index}`}>
                              <TableCell
                                align="center"
                                sx={{
                                  fontWeight: "bold",
                                  backgroundColor: dayObj.isWeekend
                                    ? "#F2F2F2"
                                    : "inherit",
                                }}
                              >
                                {dayObj.isWeekend ? "0" : stdHoursData}
                              </TableCell>

                              {isLastDayOfWeek && (
                                <TableCell
                                  sx={{
                                    fontWeight: "bold",
                                    backgroundColor: "#e0e0e0",
                                  }}
                                >
                                  {expectedWeekTotal}
                                </TableCell>
                              )}
                            </React.Fragment>
                          );
                        });
                      })()
                    : /* =============== WEEKLY MODE =============== */
                      (() => {
                        const uniqueWeeks = [
                          ...new Set(daysInMonth.map((d) => d.weekNumber)),
                        ];

                        return uniqueWeeks.map((weekNumber, weekIdx) => {
                          const weekWorkingDays = daysInMonth.filter(
                            (d) => d.weekNumber === weekNumber && !d.isWeekend
                          );

                          const expectedWeekTotal =
                            weekWorkingDays.length * stdHoursData;

                          return (
                            <TableCell
                              key={`vf-weekly-${weekIdx}`}
                              sx={{
                                fontWeight: "bold",
                                backgroundColor: "#e0e0e0",
                              }}
                            >
                              {expectedWeekTotal}
                            </TableCell>
                          );
                        });
                      })()}

                  {/* Fixed Total Columns */}
                  {/* <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 200,
                      zIndex: 2,
                    }}
                  >
                    {stdVfMonthly}
                  </TableCell> */}

                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                    }}
                  >
                    {stdMonthly}
                  </TableCell>

                  {/* <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                    }}
                  >
                    {stdDiffMonthly}
                  </TableCell> */}
                </TableRow>

                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "rgb(217, 217, 217)",
                      zIndex: 2,
                      fontWeight: "bold",
                    }}
                  >
                    Difference
                  </TableCell>

                  {viewMode === "daily"
                    ? (() => {
                        const allDays = daysInMonth;

                        return allDays.map((dayObj, index) => {
                          const dayNumber = dayObj.dayNumber;
                          const dateStr =
                            dayObj.date.toLocaleDateString("en-US");

                          // ---------- DAILY TOTAL ----------
                          const activitiesDayTotal =
                            filteredActivities?.reduce((sum, activity) => {
                              const activityEntries =
                                newd.Result?.[0]?.filter(
                                  (entry) =>
                                    entry.Activity?.toLowerCase() ===
                                    activity.AL_SalseforceCode?.toLowerCase()
                                ) || [];

                              const entriesForDay = activityEntries.filter(
                                (entry) =>
                                  new Date(
                                    entry.DateIncurred
                                  ).toLocaleDateString("en-US") === dateStr
                              );

                              return (
                                sum +
                                entriesForDay.reduce(
                                  (s, e) => s + (e.TotalRegisteredTime || 0),
                                  0
                                )
                              );
                            }, 0) || 0;

                          const reportsDayTotal = Object.values(
                            groupedReports
                          ).reduce((sum, reports) => {
                            const dayReport = reports.find(
                              (r) =>
                                new Date(r.CreatedDate).getDate() === dayNumber
                            );
                            return sum + (dayReport?.DayTime || 0);
                          }, 0);

                          const dayTotal = activitiesDayTotal + reportsDayTotal;

                          const dayStd = dayObj.isWeekend ? 0 : stdHoursData;
                          const dayDiff = dayTotal - dayStd;

                          // ---------- WEEK LOGIC ----------
                          const isLastDayOfWeek =
                            index === allDays.length - 1 ||
                            allDays[index + 1].weekNumber !== dayObj.weekNumber;

                          const weekWorkingDays = allDays.filter(
                            (d) =>
                              d.weekNumber === dayObj.weekNumber && !d.isWeekend
                          );

                          return (
                            <React.Fragment key={`diff-daily-${index}`}>
                              <TableCell
                                align="center"
                                sx={{
                                  fontWeight: "bold",
                                  backgroundColor: dayObj.isWeekend
                                    ? "#F2F2F2"
                                    : "inherit",
                                  color: dayDiff < 0 ? "error.main" : "inherit",
                                }}
                              >
                                {dayDiff.toFixed(2)}
                              </TableCell>

                              {isLastDayOfWeek &&
                                (() => {
                                  const weekActivitiesTotal =
                                    filteredActivities?.reduce(
                                      (sum, activity) => {
                                        const activityEntries =
                                          newd.Result?.[0]?.filter(
                                            (entry) =>
                                              entry.Activity?.toLowerCase() ===
                                              activity.AL_SalseforceCode?.toLowerCase()
                                          ) || [];

                                        return (
                                          sum +
                                          weekWorkingDays.reduce((dSum, d) => {
                                            const ds =
                                              d.date.toLocaleDateString(
                                                "en-US"
                                              );
                                            const entries =
                                              activityEntries.filter(
                                                (e) =>
                                                  new Date(
                                                    e.DateIncurred
                                                  ).toLocaleDateString(
                                                    "en-US"
                                                  ) === ds
                                              );
                                            return (
                                              dSum +
                                              entries.reduce(
                                                (s, e) =>
                                                  s +
                                                  (e.TotalRegisteredTime || 0),
                                                0
                                              )
                                            );
                                          }, 0)
                                        );
                                      },
                                      0
                                    ) || 0;

                                  const weekReportsTotal = Object.values(
                                    groupedReports
                                  ).reduce((sum, reports) => {
                                    return (
                                      sum +
                                      weekWorkingDays.reduce((dSum, d) => {
                                        const r = reports.find(
                                          (rep) =>
                                            new Date(
                                              rep.CreatedDate
                                            ).getDate() === d.dayNumber
                                        );
                                        return dSum + (r?.DayTime || 0);
                                      }, 0)
                                    );
                                  }, 0);

                                  const weekTotal =
                                    weekActivitiesTotal + weekReportsTotal;
                                  const weekStd =
                                    weekWorkingDays.length * stdHoursData;
                                  const weekDiff = weekTotal - weekStd;

                                  return (
                                    <TableCell
                                      sx={{
                                        fontWeight: "bold",
                                        backgroundColor: "#e0e0e0",
                                        color:
                                          weekDiff < 0
                                            ? "error.main"
                                            : "inherit",
                                      }}
                                    >
                                      {weekDiff.toFixed(2)}
                                    </TableCell>
                                  );
                                })()}
                            </React.Fragment>
                          );
                        });
                      })()
                    : /* ============== WEEKLY MODE ============== */
                      (() => {
                        const uniqueWeeks = [
                          ...new Set(daysInMonth.map((d) => d.weekNumber)),
                        ];

                        return uniqueWeeks.map((weekNumber, idx) => {
                          const weekWorkingDays = daysInMonth.filter(
                            (d) => d.weekNumber === weekNumber && !d.isWeekend
                          );

                          const weekActivitiesTotal =
                            filteredActivities?.reduce((sum, activity) => {
                              const activityEntries =
                                newd.Result?.[0]?.filter(
                                  (entry) =>
                                    entry.Activity?.toLowerCase() ===
                                    activity.AL_SalseforceCode?.toLowerCase()
                                ) || [];

                              return (
                                sum +
                                weekWorkingDays.reduce((dSum, d) => {
                                  const ds = d.date.toLocaleDateString("en-US");
                                  const entries = activityEntries.filter(
                                    (e) =>
                                      new Date(
                                        e.DateIncurred
                                      ).toLocaleDateString("en-US") === ds
                                  );
                                  return (
                                    dSum +
                                    entries.reduce(
                                      (s, e) =>
                                        s + (e.TotalRegisteredTime || 0),
                                      0
                                    )
                                  );
                                }, 0)
                              );
                            }, 0) || 0;

                          const weekReportsTotal = Object.values(
                            groupedReports
                          ).reduce((sum, reports) => {
                            return (
                              sum +
                              weekWorkingDays.reduce((dSum, d) => {
                                const r = reports.find(
                                  (rep) =>
                                    new Date(rep.CreatedDate).getDate() ===
                                    d.dayNumber
                                );
                                return dSum + (r?.DayTime || 0);
                              }, 0)
                            );
                          }, 0);

                          const weekTotal =
                            weekActivitiesTotal + weekReportsTotal;
                          const weekStd = weekWorkingDays.length * stdHoursData;
                          const weekDiff = weekTotal - weekStd;

                          return (
                            <TableCell
                              key={`diff-weekly-${idx}`}
                              sx={{
                                fontWeight: "bold",
                                backgroundColor: "#e0e0e0",
                                color: weekDiff < 0 ? "error.main" : "inherit",
                              }}
                            >
                              {weekDiff.toFixed(2)}
                            </TableCell>
                          );
                        });
                      })()}

                  {/* Fixed Total Columns */}
                  {/* <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 200,
                      zIndex: 2,
                      color:
                        Object.values(groupedReports).reduce((sum, reports) => {
                          return (
                            sum +
                            reports.reduce((reportSum, report) => {
                              return reportSum + (report.VFTime || 0);
                            }, 0)
                          );
                        }, 0) -
                          stdVfMonthly <
                        0
                          ? "error.main"
                          : "inherit",
                    }}
                  >
                    {(
                      Object.values(groupedReports).reduce((sum, reports) => {
                        return (
                          sum +
                          reports.reduce((reportSum, report) => {
                            return reportSum + (report.VFTime || 0);
                          }, 0)
                        );
                      }, 0) - stdVfMonthly
                    ).toFixed(2)}
                  </TableCell> */}

                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                      color:
                        (filteredActivities?.reduce((sum, activity) => {
                          const activityEntries =
                            newd.Result?.[0]?.filter(
                              (entry) =>
                                entry.Activity?.toLowerCase() ===
                                activity.AL_SalseforceCode?.toLowerCase()
                            ) || [];

                          return (
                            sum +
                            activityEntries.reduce(
                              (entrySum, entry) =>
                                entrySum + (entry.TotalRegisteredTime || 0),
                              0
                            )
                          );
                        }, 0) || 0) +
                          Object.values(groupedReports).reduce(
                            (sum, reports) => {
                              return (
                                sum +
                                reports.reduce((reportSum, report) => {
                                  return reportSum + (report.DayTime || 0);
                                }, 0)
                              );
                            },
                            0
                          ) -
                          stdMonthly <
                        0
                          ? "error.main"
                          : "inherit",
                    }}
                  >
                    {(
                      (filteredActivities?.reduce((sum, activity) => {
                        const activityEntries =
                          newd.Result?.[0]?.filter(
                            (entry) =>
                              entry.Activity?.toLowerCase() ===
                              activity.AL_SalseforceCode?.toLowerCase()
                          ) || [];

                        return (
                          sum +
                          activityEntries.reduce(
                            (entrySum, entry) =>
                              entrySum + (entry.TotalRegisteredTime || 0),
                            0
                          )
                        );
                      }, 0) || 0) +
                      Object.values(groupedReports).reduce((sum, reports) => {
                        return (
                          sum +
                          reports.reduce((reportSum, report) => {
                            return reportSum + (report.DayTime || 0);
                          }, 0)
                        );
                      }, 0) -
                      stdMonthly
                    ).toFixed(2)}
                  </TableCell>

                  {/* <TableCell
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#e0e0e0",
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                    }}
                  >
                    {(
                      (filteredActivities?.reduce((sum, activity) => {
                        const activityEntries =
                          newd.Result?.[0]?.filter(
                            (entry) =>
                              entry.Activity === activity.AL_SalseforceCode
                          ) || [];
                        return (
                          sum +
                          activityEntries.reduce(
                            (entrySum, entry) =>
                              entrySum + (entry.TotalRegisteredTime || 0),
                            0
                          )
                        );
                      }, 0) || 0) +
                      Object.values(groupedReports).reduce((sum, reports) => {
                        return (
                          sum +
                          reports.reduce((reportSum, report) => {
                            return (
                              reportSum +
                              ((report.DayTime || 0) - (report.VFTime || 0))
                            );
                          }, 0)
                        );
                      }, 0) -
                      stdDiffMonthly
                    ).toFixed(2)}
                  </TableCell> */}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      <Dialog
        open={isDialogOpen}
        onClose={toggleDialog}
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "600px",
            height: "auto",
            maxHeight: "80vh",
            padding: "20px",
          },
        }}
      >
        <DialogTitle>Add New Report</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {/* <TextField
                type="number"
                value="{newDayTime}"
                onChange={(e) => setNewDayTime(parseFloat(e.target.value))}
                variant="outlined"
                fullWidth
              /> */}
              <p>Activity</p>
              <FormControl fullWidth variant="outlined">
                <Select
                  value={selectedActivityId}
                  onChange={(e) => setSelectedActivityId(e.target.value)}
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "8px", // optional for rounded corners
                  }}
                >
                  {Object.keys(activityMappingnew)
                    .filter((activityId) => !groupedReports[activityId])
                    .map((activityId) => (
                      <MenuItem key={activityId} value={activityId}>
                        {activityMappingnew[activityId]}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={toggleDialog}
            sx={{
              color: "#50145A",
              "&:hover": {
                backgroundColor: "rgba(80, 20, 90, 0.1)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: "#50145A",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#3e0f45",
              },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isConfirmDialogOpen} onClose={closeDeleteDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this report?
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog} color="primary">
            No
          </Button>
          <Button onClick={confirmDeleteReport} color="error">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
      <ToastComponent ref={toastRef} timeout={4000} />
    </div>
  );
}

export default DayNew;
